<div class="scroll-wrapper">
  <div
    class="shadow left-shadow"
    [class.visible]="!atStart"
    (mouseenter)="startAutoScroll('left')"
    (mouseleave)="stopAutoScroll()"
  ></div>

  <div
    class="shadow right-shadow"
    [class.visible]="!atEnd"
    (mouseenter)="startAutoScroll('right')"
    (mouseleave)="stopAutoScroll()"
  ></div>

  <div #scrollArea class="scroll-content" (scroll)="onScroll()">
    <ng-content></ng-content>
  </div>
</div>
